module.exports = __webpack_public_path__ + "static/mobile-main-guest01-9e08b995fc4750808028accf7c314605.png";